import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowUpRight, Users, BedDouble } from "lucide-react";

export default function ApartmentCard({ apartment, index = 0 }) {
  return (
    <motion.article
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.6, delay: index * 0.08, ease: [0.16, 1, 0.3, 1] }}
      data-testid={`apartment-card-${apartment.id}`}
      className="group bg-white rounded-xl border border-[#E5E0D5]/60 overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.1)] transition-all duration-500"
    >
      <Link to={`/apartments/${apartment.id}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden bg-[#F7F3EA]">
          <img
            src={apartment.images[0]}
            alt={apartment.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          />
          <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm rounded-full px-4 py-1.5 text-xs tracking-wide font-medium text-[#2B3324]">
            {apartment.area}
          </div>
          <div className="absolute bottom-4 right-4 bg-[#6E7F5B] text-white rounded-full w-10 h-10 flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-500">
            <ArrowUpRight className="w-4 h-4" />
          </div>
        </div>

        <div className="p-7">
          <h3 className="font-display text-xl md:text-2xl font-medium tracking-tight text-[#2B3324] leading-tight">
            {apartment.short_name}
          </h3>
          <div className="flex items-center gap-2 mt-2 text-sm text-[#5C6B4D]">
            <MapPin className="w-3.5 h-3.5 text-[#C5A059] shrink-0" />
            <span className="truncate">{apartment.area}, London</span>
          </div>

          <p className="mt-5 text-sm text-[#5C6B4D] leading-relaxed line-clamp-3 font-light">
            {apartment.short_description}
          </p>

          <div className="mt-6 pt-6 border-t border-[#E5E0D5] flex items-center justify-between">
            <div className="flex items-center gap-5 text-xs text-[#5C6B4D]">
              <div className="flex items-center gap-1.5">
                <BedDouble className="w-3.5 h-3.5 text-[#C5A059]" />
                {apartment.features.bedrooms} BR
              </div>
              <div className="flex items-center gap-1.5">
                <Users className="w-3.5 h-3.5 text-[#C5A059]" />
                Sleeps {apartment.features.guests}
              </div>
            </div>
            <span
              data-testid={`view-details-${apartment.id}`}
              className="text-sm font-medium text-[#6E7F5B] group-hover:text-[#5C6B4D] tracking-wide flex items-center gap-1"
            >
              View Case Study
              <ArrowUpRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </div>
        </div>
      </Link>
    </motion.article>
  );
}
